import {BrowserModule} from '@angular/platform-browser'
import {NgModule} from '@angular/core'
import {AppRoutingModule} from './app-routing.module'
import {AppComponent} from './app.component'
import {ChartsModule} from 'ng2-charts'
import {HttpClientModule} from '@angular/common/http'
import {ComponentsModule} from './components/components.module'
import {GenerateGraphComponent} from './generate-graph/generate-graph.component'
import {DashboardComponent} from './dashboard/dashboard.component'
import {AngularFireModule} from '@angular/fire'
import {AngularFireAuthModule} from '@angular/fire/auth'
import {AngularFirestoreModule} from '@angular/fire/firestore'
import {environment} from '../environments/environment'
import {GraficoComponent} from './grafico/grafico.component'
import {DashboardsComponent} from './dashboards/dashboards.component'
import {NgbModule} from '@ng-bootstrap/ng-bootstrap'
import {NoopAnimationsModule} from '@angular/platform-browser/animations'
import {
  NbThemeModule,
  NbLayoutModule,
  NbSidebarService,
  NbSidebarModule,
  NbCardModule,
  NbMenuModule,
  NbUserModule,
  NbContextMenuModule,
  NbToastrModule,
  NbListModule,
  NbTooltipModule,
  NbDialogModule
} from '@nebular/theme'
import {AngularFontAwesomeModule} from 'angular-font-awesome'
import {HomeComponent} from './home/home.component'
import {NbPasswordAuthStrategy, NbAuthModule} from '@nebular/auth'
import {LoginModule} from './login/login.module'
import * as eva from 'eva-icons'
import {MainComponent} from './main/main.component'
import {LipricesComponent} from './liprices/liprices.component'
import {AuthComponent} from './auth/auth.component'
import {NbToastrConfig} from '@nebular/theme/components/toastr/toastr-config'
import {ListatsComponent} from './listats/listats.component'
import {FormsModule} from '@angular/forms'
import {GoogleanalyticsService} from './googleanalytics.service'
import {PaymentModule} from './components/payment/payment.module'

@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    GenerateGraphComponent,
    DashboardComponent,
    GraficoComponent,
    DashboardsComponent,
    HomeComponent,
    MainComponent,
    LipricesComponent,
    ListatsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ChartsModule,
    ComponentsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    NgbModule,
    NoopAnimationsModule,
    NbThemeModule.forRoot({name: 'default'}),
    NbLayoutModule,
    AngularFontAwesomeModule,
    NbSidebarModule,
    NbCardModule,
    NbMenuModule.forRoot(),
    NbToastrModule.forRoot(),
    NbUserModule,
    NbContextMenuModule,
    LoginModule,
    PaymentModule,
    FormsModule,
    NbListModule,
    NbAuthModule.forRoot({
      strategies: [
        NbPasswordAuthStrategy.setup({
          name: 'email'
        })
      ],
      forms: {}
    }),
    NbDialogModule.forChild()
  ],
  providers: [ComponentsModule, NbSidebarService, GoogleanalyticsService],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(protected _googleAnalyticsService: GoogleanalyticsService) {}
}
